module.exports = __webpack_public_path__ + "public/images/prizes/prize-uae-4.5927b7ea42147698ba7b35edc61ffa91.webp";